<template>
  <div>
    <!-- 直降价格 -->
    <div class="straight_down_price" v-if="nowAcvitity.promotionName">
      <div class="start_price">
        <div class="left_price">
          <div class="sale_price">
            <span>￥</span
            ><b>{{
              calculationPrice(
                nowAcvitity.state === 0 ? nowAcvitity.price : nowAcvitity.promotionPrice,
              ).b
            }}</b>
            <span>
              {{
                calculationPrice(
                  nowAcvitity.state === 0 ? nowAcvitity.price : nowAcvitity.promotionPrice,
                ).s
              }}</span
            >
            <p v-if="nowAcvitity.stockType === 2 && nowAcvitity.state === 1">
              再售{{ nowAcvitity.stockNum }}件恢复原价
            </p>
          </div>
          <div class="origin_price">
            <span v-if="nowAcvitity.state === 0">活动价</span
            ><b v-if="nowAcvitity.state === 0">￥{{ nowAcvitity.promotionPrice }}</b>
            <s v-else>￥{{ nowAcvitity.price }}</s>
            <span class="sale_num" v-if="nowAcvitity.state === 1 && nowAcvitity.stockType !== 2"
              >{{ courseBaseData.realSales + courseBaseData.initialSales }}人已抢购</span
            >
          </div>
        </div>
        <div class="right_time">
          <div class="time1" v-if="timeType === 1">{{ times }} <br />即将开始</div>
          <div class="time2" v-else>
            <p>{{ nowAcvitity.state === 0 ? '活动开始倒计时' : '活动结束倒计时' }}</p>
            <div>
              <b class="day" v-if="times.d !== '00'">{{ times.d }}</b>
              <b>{{ times.h }}</b>
              <b>{{ times.m }}</b>
              <b>{{ times.s }}</b>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import {
  priceCount, dateTime, timerCount, replaceHyphens,
} from '../../utils/tools';

export default {
  components: {},
  data() {
    return {
      times: '', // 时间展示
      timeType: 0, // 1 大于3天 2小于3天
      timers: null, // 定时器
    };
  },
  props: {
    nowAcvitity: {
      type: Object,
      default: () => {},
    },
    currentTime: {
      type: Number,
      default: 0,
    },
  },

  computed: {
    ...mapState(['courseBaseData']),
  },
  watch: {
    nowAcvitity: {
      handler() {
        this.checkTime();
      },
      immediate: true,
      deep: true,
    },
  },
  created() {},
  mounted() {},
  destroyed() {
    clearInterval(this.timers);
  },
  methods: {
    // 价格小数位处理
    calculationPrice(price) {
      return priceCount(price);
    },
    // 校验开始/结束时间是否大于3天 区分展示时间ui
    checkTime() {
      let startTime = '';
      // alert(this.nowAcvitity.state);
      if (this.nowAcvitity.state === 0) {
        // 未开始
        startTime = new Date(replaceHyphens(this.nowAcvitity.startTime)).getTime();
      } else {
        // 进行中
        startTime = new Date(replaceHyphens(this.nowAcvitity.endTime)).getTime();
        // alert(startTime);
      }
      let temp = startTime - this.currentTime + 1000;

      if (temp / (1000 * 60 * 60 * 24) > 3 && this.nowAcvitity.state === 0) {
        this.timeType = 1;
        this.times = `${dateTime(startTime).month}月${dateTime(startTime).day}日${
          dateTime(startTime).h
        }:${dateTime(startTime).m}`;
      } else {
        this.timeType = 2;
        this.times = timerCount(temp, 2);
        this.timers = setInterval(() => {
          temp -= 1000;
          if (temp > 0) {
            this.times = timerCount(temp, 2);
          } else {
            // 倒计时结束  重新拉取接口请求
            clearInterval(this.timers);
            this.$emit('triggerGetActive', true);
          }
        }, 1000);
      }
    },
  },
};
</script>
<style scoped lang="scss">
// 直降
.straight_down_price {
  width: 100%;
  height: 108px;
  .start_price {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 108px;
    background: url('../../assets/img/productDetail/straightDown_bg.png') no-repeat;
    background-size: 100%;

    .left_price {
      height: 108px;
      padding-left: 120px;

      .sale_price {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        height: 40px;
        padding-top: 30px;

        span {
          color: #fff;
          font-size: 33px;
        }
        b {
          color: #fff;
          font-size: 43px;
        }
        p {
          height: 34px;
          margin-left: 15px;
          padding: 0 10px;
          color: #fff;
          font-size: 22px;
          line-height: 34px;
          background: #ffb27b;
          border-radius: 17px;
        }
      }
      .origin_price {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        height: 70px;

        span,
        s,
        b {
          color: #fff;
          font-size: 22px;
        }
        span.sale_num {
          padding-left: 10px;
        }
      }
    }
    .right_time {
      padding-right: 21px;
      .time1 {
        color: #ff6c02;
        font-size: 22px;
        line-height: 28px;
        text-align: center;
      }
      .time2 {
        height: 108px;
        p {
          height: 40px;
          padding-top: 20px;
          color: #ff6c02;
          font-size: 22px;
          text-align: right;
        }
        div {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          height: 30px;
          padding-top: 28px;

          b.day {
            margin-right: 8px;
            &::after {
              top: 15px;
              right: -30px;
              font-size: 22px;
              content: '天';
            }
          }
          b {
            position: relative;
            display: inline-block;
            min-width: 32px;
            height: 32px;
            margin-left: 26px;
            color: #fff;
            font-weight: bold;
            font-size: 22px;
            line-height: 32px;
            text-align: center;
            background: #ff6c02;
            border-radius: 7px;

            &::after {
              position: absolute;
              top: 15px;
              right: -15px;
              display: inline-block;
              color: #ff6c02;
              font-weight: 500;
              font-size: 22px;
              transform: translateY(-50%);
              content: ':';
            }
          }

          b:last-child {
            &::after {
              display: none;
            }
          }
        }
      }
    }
  }
}
</style>
